<template>
  <el-menu
    class="el-menu-vertical-demo"
    style="height:100%; z-index:1002"
    :default-active="menu.defaultActive"
    :default-opened="menu.defaultOpened"
    :background-color="menu.backgroundColor"
    :text-color="menu.textColor"
    :active-text-color="menu.activeTextColor"
    :collapse="menu.isCollapse"
    @open="handleOpen"
    @close="handleClose">
    <el-row>
    <el-col :span="24"><div style="text-align: right; font-size: 24px; margin:10px 20px; color:#ffffff">
      <i :class="collapseIcon" style="cursor: pointer;" @click="handleCollapse"></i>
    </div></el-col>
    <div class="logo"><img src="@/assets/backstage/logo.png"></div>
    <el-col :span="24">
      <div v-if="!menu.isCollapse" style="text-align: left; font-size: 22px; margin:10px 20px; text-align:left; color:#ffffff">
        {{menu.title.fullTitle}}
      </div>
      <div v-if="!menu.isCollapse" style="text-align: left; font-size: 18px; margin:10px 20px; text-align:left; color:#ffffff">
        {{menu.title.subTitle}}
      </div>
    </el-col>
    <el-col :span="24"><div v-if="menu.isCollapse" style="text-align: left; font-size: 16px; margin:10px 5px; text-align:center; color:#ffffff">
      {{menu.title.shortTitle}}
    </div></el-col>
    </el-row>
    <!--選單-->
    <SidebarMenuList
      :list="menu.list"
      :isCollapse="menu.isCollapse"
      @child-selected="handleMenuSelected">
    </SidebarMenuList>
  </el-menu>
</template>

<script>
// import axios from 'axios'
import SidebarMenuList from './SidebarMenuList.vue'

export default {
  props: ['menu'],
  components: {
    SidebarMenuList
  },
  data () {
    return {
    }
  },
  computed: {
    collapseIcon () {
      if (this.menu.isCollapse) {
        return 'el-icon-arrow-right'
      } else {
        return 'el-icon-close'
      }
    },
    showTitle () {
      if (this.menu.isCollapse) {
        return this.title.shortTitle
      } else {
        return this.title.fullTitle
      }
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleCollapse () {
      this.menu.isCollapse = !this.menu.isCollapse
    },
    handleMenuSelected (item) {
      this.$emit('child-selected', item)
    }
  },
  created () {
    // this.menu.defaultActive = this.currentPage.path
    // this.menu.defaultOpeneds = [this.currentPage.path]
  },
  mounted () {
    // console.log(this.currentPage.path)
  },
  watch: {
    'menu.isCollapse': {
      handler (val) {
        if (this.menu.isCollapse) {
          var self = this
          setTimeout(() => {
            self.$emit('child-onCollapse', true)
          }, 300)
        } else {
          this.$emit('child-onCollapse', false)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .logo {
    text-align: center;
    img {
      width: 90%;
    }
  }
</style>
